import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ButtonVariant } from '@bmw-ds/components';

@Component({
    selector: 'sera-confirmation-dialog',
    templateUrl: './sera-confirmation-dialog.component.html',
    styleUrls: ['./sera-confirmation-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SeraConfirmationDialogComponent implements OnInit {
    @Input()
    key!: string;

    @Input()
    style: {} = { width: '576px' };

    @Input()
    headerIcon: string = 'ci ci-alert';

    @Input()
    headerStyleClass: string | null = null;

    @Input()
    title: string = 'WARNING.CAUTION_TITLE.LBL';

    @Input()
    showtitleIcon: boolean = true;

    @Input()
    messageToShow!: string;

    @Input()
    primaryButtonLabel: string = 'PAGE.GENERAL.CONTINUE.LBL';

    @Input()
    secondPrimaryButtonLabel: string = 'PAGE.GENERAL.YES.LBL';

    @Input()
    secondaryButtonLabel: string = 'PAGE.GENERAL.CANCEL.BT';

    @Input()
    dialogType: 'WARNING' | 'INFO' | 'CRITICAL' | 'POSITIVE' | 'NEUTRAL' = 'NEUTRAL';

    @Input()
    innerHtmlMessage: boolean = false;

    @Input()
    isToHaveTwoPrimaryButtons: boolean = false;

    @Input()
    isWithUUID: boolean = false;

    @Input()
    hideSecondaryButton: boolean = true;

    @Input()
    showDoNotShowAgain: boolean = false;

    @Input()
    primaryButtonVariant: ButtonVariant = 'primary';

    @Output()
    doNotShowAgainChange = new EventEmitter<string>();

    dialogHeaderColor: string = '';
    dialogPrimaryButtonVariant: ButtonVariant = 'primary';
    dialogSecondaryButtonVariant: ButtonVariant = 'outline';
    dialogTertiaryButtonVariant: ButtonVariant = 'ghost';
    doNotShowAgainChecked: boolean = false;

    ngOnInit() {
        this.dialogHeaderColor = this.getColorOfDialogHeaderBar();
        this.dialogPrimaryButtonVariant = this.primaryButtonVariant;
    }

    getColorOfDialogHeaderBar(): string {
        switch (this.dialogType) {
            case 'CRITICAL':
                return '#DF001A';
            case 'INFO':
                return '#0071C5';
            case 'POSITIVE':
                return '#2A813F';
            case 'WARNING':
                return '#F6C800';
            case 'NEUTRAL':
                return '';
        }
    }

    onAccept(cd: any) {
        cd.onAccept();
        if (this.doNotShowAgainChecked) {
            this.doNotShowAgainChange.emit(this.key);
        }
    }
}
